import { render, staticRenderFns } from "./SMSTemplate.vue?vue&type=template&id=f32223a6&"
import script from "./SMSTemplate.vue?vue&type=script&lang=js&"
export * from "./SMSTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports